import { useTranslation } from 'react-i18next'

import { USER_STATUS_TEXT } from '../../../constants/user'
import { Status } from '../../Status'

function UserStatusTag({ className, height, textClassName, value }) {
  const { t } = useTranslation()

  const status = USER_STATUS_TEXT[value]

  return status ? (
    <Status
      className={className}
      height={height}
      text={t(status.text)}
      textClassName={textClassName}
      textColor={status.color}
    />
  ) : null
}

export default UserStatusTag
